import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { TrainingDocument } from './get-skills-matrix';

export async function setSupervisorRatings(
   userids: number[],
   docs: TrainingDocument[],
   rating: number,
   teamid?: number,
   common: CommonRequestOptions = {}
): Promise<null> {
   return makeRequest('post', `skills/ratings/supervisor`, {
      ...common,
      body: {
         userids,
         docs,
         rating,
         teamid,
      },
   });
}
